import dayjs from "dayjs";
import { date, number, object, string } from "yup";

export const DEFAULT_VALUES = {
  seller: null,
  buyer: null,
  buyerableType: null,
  salesOrder: null,
  transactionDate: dayjs(),
  amount: null,
  paymentTerm: null,
  note: "",
};

export const VALIDATION_SCHEMA = object().shape({
  seller: object().nullable().required("Harus diisi"),
  buyer: object().nullable().required("Harus diisi"),
  salesOrder: object().nullable().required("Harus diisi"),
  transactionDate: date().nullable().required("Harus diisi"),
  amount: number()
    .nullable()
    .typeError("Harus diisi")
    .positive("Harus lebih dari 0")
    .required("Harus diisi")
    .test(
      "max-available-down-payment",
      "Tidak boleh melebihi Sisa Uang Muka Tersedia",
      function (value) {
        const availableAmount =
          this.parent.salesOrder?.availableDownPaymentAmount;
        if (availableAmount == null) return true;
        return value <= availableAmount;
      },
    ),
  paymentTerm: object().nullable().required("Harus diisi"),
  note: string().nullable(),
});
